module.exports = __webpack_public_path__ + "img/signup-guide-02-03.41825521.png";